import {
  Button,
  Container,
  LoadingOverlay,
  Modal,
  Table,
  useMantineTheme,
} from "@mantine/core";
import "./Results.css";
import { randomId, useMediaQuery } from "@mantine/hooks";
import { useEffect, useState } from "react";
import Toast from "./../Toast";
import {
  deleteSubApi,
  deleteSubFileApi,
  fetchMenteeSubmissionsApi,
} from "./../../api/tasks";

async function fetchMenteeSubmissions() {
  const res = await fetchMenteeSubmissionsApi().catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res == null) return [];
  if (res.status == 200) {
    return res.data;
  } else {
    Toast("ERROR", res.data.message, "red");
    return [];
  }
}

async function deleteSub(subId) {
  const res = await deleteSubApi(subId).catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res != null) {
    if (res.status == 200) {
      Toast("Success", res.data.message, "green");
      return true;
    } else {
      Toast("ERROR", res.data.message, "red");
      return;
    }
  } else return;
}

async function deleteSubFile(taskId) {
  const res = await deleteSubFileApi(taskId).catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res != null) {
    if (res.status == 200) {
      Toast("Success", res.data.message, "green");
      return true;
    } else {
      Toast("ERROR", res.data.message, "red");
      return;
    }
  } else return;
}

export default function Results() {
  const [opened, setOpened] = useState(false);
  const [sub, setsub] = useState({});
  const [subLoad, setsubLoad] = useState(true);
  const [deleteLoad, setdeleteLoad] = useState(false);
  const isScreenLarge = useMediaQuery("(min-width: 400px)", false);
  const [fetchAgain, setfetchAgain] = useState(true);
  const [isChange, setisChange] = useState(false);
  var theme = useMantineTheme();
  useEffect(() => {
    fetchMenteeSubmissions().then((res) => {
      setsub(res);
      setsubLoad(false);
    });
  }, [fetchAgain]);
  const [submission, setSubmission] = useState({
    id: null,
    taskId: null,
    userId: null,
    createdAt: null,
    updatedAt: null,
    link: null,
    content: null,
    fileName: null,
    marks: null,
    penalty: null,
    remarks: null,
    file: null,
    subAllowed: null,
  });
  let rows = [];
  if (sub.submissions != null) {
    sub.submissions.map((submission) => {
      rows.push(
        <tr key={randomId()}>
          <td>{submission.domain}</td>
          <td>{submission.taskNo}</td>
          <td>{submission.marks != null ? "Yes" : "No"}</td>
          <td>
            <Button
              gradient={{ from: "#0063F8", to: "#3391FF" }}
              variant="gradient"
              onClick={() => {
                setOpened(true);
                setSubmission(submission);
              }}
            >
              View
            </Button>
          </td>
        </tr>
      );
    });
  }

  return (
    <>
      <Modal
        centered
        size="90%"
        opened={opened}
        onClose={() => {
          if (isChange == true) {
            setisChange(false);
            setsubLoad(true);
            setfetchAgain(!fetchAgain);
          }
          setOpened(false);
        }}
      >
        <LoadingOverlay visible={deleteLoad} />
        <Container
          style={{
            padding: "20px",
            fontSize: isScreenLarge == false ? "11px" : "15px",
          }}
        >
          <div id="submission-data" style={{ fontWeight: "bold" }}>
            <h3>Submission Details</h3>
            <p>Domain: {submission.domain}</p>
            <p>Task: {submission.taskNo}</p>
            <p style={{ display: submission.link == null ? "none" : "block" }}>
              Link:{" "}
              <a rel="noreferrer" target={"_blank"} href={submission.link}>
                {submission.link}
              </a>
            </p>
            <p
              style={{ display: submission.content == null ? "none" : "block" }}
            >
              Comments: {submission.content}{" "}
            </p>
            <div
              style={{ display: submission.file == null ? "none" : "inline" }}
            >
              Submitted File :{" "}
              <div>
                <a
                  style={{
                    display: submission.file == null ? "none" : "inline",
                  }}
                  href={submission.file}
                  download
                >
                  <Button
                    gradient={{ from: "#0063F8", to: "#3391FF" }}
                    variant="gradient"
                    style={{
                      extDecoration: "none",
                      color: "white",
                      marginTop: "16px",
                      fontSize: isScreenLarge == false ? "11px" : "15px",
                      marginLeft: "16px",
                    }}
                  >
                    Download
                  </Button>
                </a>
                <Button
                  color={"red"}
                  style={{
                    extDecoration: "none",
                    color: "white",
                    marginTop: "16px",
                    marginLeft: "16px",
                    fontSize: isScreenLarge == false ? "11px" : "15px",
                    display:
                      submission.file != null && submission.subAllowed == true
                        ? "inline"
                        : "none",
                  }}
                  onClick={() => {
                    setdeleteLoad(true);
                    deleteSubFile(submission.taskId).then((done) => {
                      if (done != null) {
                        setSubmission({
                          ...submission,
                          file: null,
                        });
                        setisChange(true);
                      }
                      setdeleteLoad(false);
                    });
                  }}
                >
                  Delete File
                </Button>
              </div>
            </div>

            <Button
              color={"red"}
              style={{
                extDecoration: "none",
                color: "white",
                fontSize: isScreenLarge == false ? "11px" : "15px",
                marginTop: "20px",
                display: submission.subAllowed == true ? "block" : "none",
              }}
              onClick={() => {
                setdeleteLoad(true);
                deleteSub(submission.id).then((done) => {
                  if (done != null) {
                    setsubLoad(true);
                    setfetchAgain(!fetchAgain);
                    setOpened(false);
                  }
                  setdeleteLoad(false);
                });
              }}
            >
              Delete Submission
            </Button>
            <div
              style={{
                padding: "30px",
                marginTop: "20px",
                boxShadow:
                  theme.colorScheme === "dark"
                    ? "2px 2px 5px rgb(50,50,50)"
                    : "2px 2px 5px rgb(220, 220, 220)",
                display: submission.marks == null ? "block" : "none",
              }}
            >
              <div>
                <p>Submission yet to be graded</p>
              </div>
            </div>
            <div
              style={{
                padding: "30px",
                marginTop: "20px",
                boxShadow:
                  theme.colorScheme === "dark"
                    ? "2px 2px 5px rgb(50,50,50)"
                    : "2px 2px 5px rgb(220, 220, 220)",
                display: submission.marks != null ? "block" : "none",
              }}
            >
              <div>
                <p>Marks: {submission.marks}</p>
              </div>
              <div>
                <p>Penalty: {submission.penalty}</p>
              </div>
              <div>
                <p>Remarks: {submission.remarks}</p>
              </div>
            </div>
          </div>
        </Container>
      </Modal>
      <Container style={{ width: "100%" }}>
        <h2 style={{ textAlign: "center" }}>Submissions</h2>
        <div
          style={{
            marginTop: "15px",
            borderRadius: "5px",
            overflow: "auto",
            position: "relative",
            width: "100%",
          }}
        >
          <LoadingOverlay visible={subLoad} />
          <Table
            highlightOnHover
            horizontalSpacing="md"
            verticalSpacing="sm"
            fontSize="md"
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#0063F8",
                  textAlign: "center",
                }}
              >
                <th style={{ color: "white", textAlign: "center" }}>Domain</th>
                <th style={{ color: "white", textAlign: "center" }}>Task</th>
                <th style={{ color: "white", textAlign: "center" }}>Graded</th>
                <th style={{ color: "white", textAlign: "center" }}>View</th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        </div>
      </Container>
    </>
  );
}
